import $ from 'jquery'
import $container from "bootstrap/js/src/dom/selector-engine.js";

export class Banner {

  constructor($container) {
    this.$container = $container

    if (this.$container === undefined) {
      return
    }

    this.$window = $(window)

    this.classes = {
      isSticky: 'is-sticky',
      stickyClass: 'banner-sticky',
      closeButtonClass: 'banner-close',
    }

    if (this.$container.hasClass(this.classes.isSticky)) {
      this.$buttonClose = this.$container.find(`.${this.classes.closeButtonClass}`)

      this.$window.on('scroll resize', this.handleFixHeightBanner.bind(this))
      this.$buttonClose.on('click', this.handleClickCloseButton.bind(this))

      this.handleFixHeightBanner()
    }
  }

  handleFixHeightBanner(e) {
    let height = this.$container.find('.banner-sticky').outerHeight(true)

    this.$container.css('height', `${height}px`)
  }

  handleClickCloseButton(e) {
    this.$container.remove()
  }
}
